"use client";

import React, { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface Stat {
  label: string;
  value: number;
  suffix?: string;
}
const stats: Stat[] = [{
  label: "Accuracy Rate",
  value: 99,
  suffix: ".9%"
}, {
  label: "Clinical Insights",
  value: 50000,
  suffix: "+"
}, {
  label: "Genetic Markers",
  value: 150,
  suffix: "+"
}, {
  label: "Providers Linked",
  value: 1200,
  suffix: "+"
}];
function AnimatedNumber({
  value,
  suffix = ""
}: {
  value: number;
  suffix?: string;
}) {
  const [count, setCount] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLSpanElement>({
    once: true,
    threshold: 0.5
  });
  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const duration = 2000;
    const frameRate = 1000 / 60;
    const totalFrames = Math.round(duration / frameRate);
    const increment = value / totalFrames;
    const timer = setInterval(() => {
      start += increment;
      if (start >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, frameRate);
    return () => clearInterval(timer);
  }, [isVisible, value]);
  return <span ref={ref} className="font-default text-6xl md:text-[64px] font-bold text-primary tracking-tighter">
      {count.toLocaleString()}
      {suffix}
    </span>;
}
export default function ImpactInNumbers() {
  return <section data-section-id="224164" id="innovation-by-the-numbers" className="dark bg-background text-foreground py-16 md:py-24 border-y border-border bg-[linear-gradient(to_right,hsl(var(--foreground)/.05)_1px,transparent_1px),linear-gradient(to_bottom,hsl(var(--foreground)/.05)_1px,transparent_1px)] bg-[size:60px_60px]">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between w-full">
          {stats.map((stat, i) => <div key={stat.label} data-index={i} className="flex-1 flex flex-col items-center justify-center w-full py-10 md:py-4 border-b md:border-b-0 md:border-r border-border/50 last:border-b-0 last:border-r-0 transition-colors duration-300 hover:bg-primary/5">
              <AnimatedNumber value={stat.value} suffix={stat.suffix} />
              <span className="mt-4 font-mono text-sm font-semibold tracking-widest uppercase text-muted-foreground">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}